import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4 md:max-w-[680px] md:min-w-[48%] md:gap-7 xl:shrink-0',

    imageWrapper: 'relative block shrink-0',
    image: 'w-full object-contain md:max-h-[318px] md:max-w-[680px]',
    labels: 'absolute top-3 left-3 flex flex-col gap-1 md:top-5 md:left-5',

    contentWrapper: 'flex flex-col justify-between gap-4 md:gap-9',
    text: 'flex flex-col gap-2 md:gap-3',
    title: 'heading-xl md:heading-2xl',
    subtitle: 'heading-xs md:heading-m',

    commerce: 'flex justify-between max-md:flex-col max-md:gap-5',
    prices: 'items-center',
    price: 'heading-2xl md:heading-3xl',
    oldPrice: 'text-lg md:text-xl',
    button: 'md:w-[44%]'
  },
  variants: {
    isInCart: {
      true: {
        button: 'bg-blue text-white'
      }
    }
  }
});
